var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-19 (5) 1",
    clipPath: "url(#clip0_2319_13310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.7075 0.110352H4.98252C2.23516 0.110352 0 2.34551 0 5.09287V51.5964C0 54.3437 2.23516 56.5789 4.98252 56.5789H51.7075C54.4548 56.5789 56.69 54.3437 56.69 51.5964V5.09287C56.69 2.34551 54.4548 0.110352 51.7075 0.110352ZM4.98252 3.43203H51.7075C52.6233 3.43203 53.3683 4.17708 53.3683 5.09287V13.3971H3.32168V5.09287C3.32168 4.17708 4.06673 3.43203 4.98252 3.43203ZM51.7075 53.2572H4.98252C4.06673 53.2572 3.32168 52.5122 3.32168 51.5964V16.7188H53.3683V51.5964C53.3683 52.5122 52.6233 53.2572 51.7075 53.2572Z",
    fill: "#0784C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.9805 21.8359C33.1374 21.4746 32.161 21.8651 31.7997 22.7081L21.8347 45.9599C21.4733 46.8029 21.8639 47.7794 22.7069 48.1407C23.5503 48.5021 24.5265 48.1112 24.8877 47.2684L34.8528 24.0167C35.2142 23.1735 34.8235 22.1972 33.9805 21.8359ZM19.6756 27.3073C19.1025 26.5911 18.0571 26.475 17.3412 27.048L9.037 33.6914C8.20669 34.3554 8.20614 35.6206 9.037 36.2852L17.3412 42.9285C18.0575 43.5016 19.1028 43.3854 19.6756 42.6692C20.2486 41.953 20.1325 40.9077 19.4161 40.3349L12.7331 34.9883L19.4161 29.6418C20.1325 29.0688 20.2486 28.0237 19.6756 27.3073ZM47.6504 33.6914L39.3462 27.048C38.63 26.4749 37.5847 26.5911 37.0119 27.3073C36.4389 28.0236 36.5549 29.0688 37.2713 29.6417L43.9543 34.9883L37.2713 40.3347C36.5549 40.9077 36.4389 41.9528 37.0119 42.6691C37.5856 43.3862 38.631 43.5009 39.3462 42.9284L47.6504 36.2851C48.4807 35.6211 48.4813 34.3559 47.6504 33.6914Z",
    fill: "#0784C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.41475 10.0756C9.332 10.0756 10.0756 9.332 10.0756 8.41475C10.0756 7.49749 9.332 6.75391 8.41475 6.75391C7.49749 6.75391 6.75391 7.49749 6.75391 8.41475C6.75391 9.332 7.49749 10.0756 8.41475 10.0756Z",
    fill: "#0784C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.0593 10.0756C15.9765 10.0756 16.7201 9.332 16.7201 8.41475C16.7201 7.49749 15.9765 6.75391 15.0593 6.75391C14.142 6.75391 13.3984 7.49749 13.3984 8.41475C13.3984 9.332 14.142 10.0756 15.0593 10.0756Z",
    fill: "#0784C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.6999 10.0756C22.6172 10.0756 23.3607 9.332 23.3607 8.41475C23.3607 7.49749 22.6172 6.75391 21.6999 6.75391C20.7826 6.75391 20.0391 7.49749 20.0391 8.41475C20.0391 9.332 20.7826 10.0756 21.6999 10.0756Z",
    fill: "#0784C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M38.3093 10.0756H48.2743C49.1915 10.0756 49.9352 9.33197 49.9352 8.41475C49.9352 7.49752 49.1915 6.75391 48.2743 6.75391H38.3093C37.3921 6.75391 36.6484 7.49752 36.6484 8.41475C36.6484 9.33197 37.3921 10.0756 38.3093 10.0756Z",
    fill: "#0784C9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2319_13310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.69,
    height: 56.69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebD);
export default __webpack_public_path__ + "static/media/webD.3952c0e046d59dac40aacc2962a3d0a1.svg";
export { ForwardRef as ReactComponent };